import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { APP_ROUTES, AppComponent } from 'app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { AuthInterceptor } from '@scl/shared/interceptors/auth-interceptor';
import { clerkAuthInterceptor } from '@scl/shared/interceptors/clerk-auth.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic(providers).bootstrapModule(AppModule)
//   .catch(err => console.log(err));

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideNativeDateAdapter(),
    provideRouter(APP_ROUTES,
      withPreloading(PreloadAllModules)  // Enable preloading  
    ),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([clerkAuthInterceptor]),
      withInterceptorsFromDi() // to use the below interceptor
    ),  
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // other providers...
  ]
});

//export { renderModule, renderModuleFactory } from '@angular/platform-server';
